'use client';

import Button from '@/components/atoms/shared/Button';
import { Card, CardContent, CardDescription, CardHeader } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';
import { useRouter } from 'next/navigation';

/** 페이지를 찾을수 없습니다 페이지 */
export default function NotFoundPage() {
  const router = useRouter();
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white">
      <Card className="w-full max-w-md shadow-none">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <AlertTriangle className="h-6 w-6 text-red-600" />
          </div>
          <CardDescription className="text-xl font-bold text-gray-600">
            존재하지 않는 페이지입니다
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex justify-center gap-2">
            <Button onClick={() => router.back()} className="w-full" size="lg" variant="blue">
              이전 페이지로
            </Button>
            <Button
              onClick={() => router.push('/')}
              className="w-full"
              size="lg"
              variant="solid" intent="neutral"
            >
              홈으로
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
